module.exports = __webpack_public_path__ + "static/img/early-settlement-banner.ab57cb99.png";